import { userFromBack, userToBack } from '@entities/User/responseFormatters';
import { emptyStringToNull } from '@root/src/utils/commons/objects';
import { parseUTCDate } from '@root/src/utils/formatters/dates';
import { CONVERSATION_PARTICIPANT_STATUS } from './status';
import { ConversationBack, ConversationFront } from './types';

export const conversationFromBack = ({
  _id,
  participants,
  status,
  unread,
  lastMessageTimestamp,
}: ConversationBack): ConversationFront => ({
  id: _id,
  participants: participants.map(userFromBack),
  status: status ?? CONVERSATION_PARTICIPANT_STATUS.INBOX,
  unread,
  ...(lastMessageTimestamp && { lastMessageTimestamp: parseUTCDate(lastMessageTimestamp) }),
});

export const conversationToBack = ({
  id,
  participants,
  status,
  unread,
  lastMessageTimestamp,
}: ConversationFront): ConversationBack => {
  const payload: ConversationBack = {
    _id: id,
    participants: participants?.map(userToBack) as ConversationBack['participants'],
    ...(status && status !== CONVERSATION_PARTICIPANT_STATUS.INBOX ? { status } : {}),
    unread,
    ...(lastMessageTimestamp && {
      lastMessageTimestamp: lastMessageTimestamp.toISOString(),
    }),
  };

  // Convert all empty strings and undefined values to null for standardization
  return emptyStringToNull(payload);
};
